import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-expand",
  "use": "icon-expand-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol viewBox=\"0 0 22 22\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-expand\">\n<g clip-path=\"url(#icon-expand_clip0_8764_4768)\">\n<path d=\"M11 0C4.92461 0 0 4.92461 0 11C0 17.0754 4.92461 22 11 22C17.0754 22 22 17.0754 22 11C22 4.92461 17.0754 0 11 0ZM11 20.2812C5.87396 20.2812 1.71875 16.126 1.71875 11C1.71875 5.87396 5.87396 1.71875 11 1.71875C16.126 1.71875 20.2812 5.87396 20.2812 11C20.2812 16.126 16.126 20.2812 11 20.2812Z\" fill=\"#314455\" />\n<path d=\"M13.75 8.9375H8.25V13.0625H13.75V8.9375Z\" fill=\"#314455\" />\n<path d=\"M7.5625 12.3757V9.625L6.1875 11L7.5625 12.3757Z\" fill=\"#314455\" />\n<path d=\"M14.4375 12.3757L15.8132 11L14.4375 9.625V12.3757Z\" fill=\"#314455\" />\n</g>\n<defs>\n<clipPath id=\"icon-expand_clip0_8764_4768\">\n<rect width=\"22\" height=\"22\" fill=\"white\" />\n</clipPath>\n</defs>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/expand.svg
// module id = oHS6
// module chunks = 262